import React, { useState } from "react";
import { CustomCardType } from "../types/CustomCardType";
import classes from "./CustomLineChartCard.module.css";
import { Divider } from "antd";
import { AgChartsReact } from "ag-charts-react";
import { AgChartOptions, time } from "ag-charts-community";
import {
	AreaChart,
	Area,
	Tooltip,
	CartesianGrid,
	XAxis,
	YAxis,
	ResponsiveContainer,
} from "recharts";

const tempData = [
	{
		name: "June",
		pv: 700,
		amt: 2400,
	},
	{
		name: "July",
		pv: 1200,
		amt: 2210,
	},
	{
		name: "August",
		pv: 1600,
		amt: 2290,
	},
	{
		name: "September",
		pv: 780,
		amt: 2000,
	},
	{
		name: "October",
		pv: 1890,
		amt: 2181,
	},
	{
		name: "December",
		pv: 2390,
		amt: 2500,
	},
];

const CustomChartLineCard = ({
	title,
	cash,
	firstLine,
	secondLine,
	thirdLine,
	style,
}: CustomCardType) => {
	return (
		<div className={classes.mainContainer} style={style}>
			<div className={classes.titleContainer}>
				<p className={classes.title}>{title}</p>
			</div>
			<div className={classes.firstContainer}>
				<div className={classes.firstInfo}>
					{/* <div> rather than <p>: these lines now accept React nodes (a dual-currency
					    figure renders its own block element) and a <div> inside a <p> is invalid
					    nesting that React will warn about. Styling is unchanged — both are block
					    elements and the classes set every property that differs. */}
					<div className={classes.firstLine}>{firstLine}</div>
					<div className={classes.line}></div>
					<div className={classes.secondLine}>{secondLine}</div>
					<div className={classes.thirdLine}>{thirdLine}</div>
				</div>
				<div className={classes.secondContainer}>
					<ResponsiveContainer width="100%" height={200}>
						<AreaChart
							// width={350}
							// height={210}
							data={tempData}
							margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
						>
							<defs>
								<linearGradient
									id="colorPv"
									x1="0"
									y1="0"
									x2="0"
									y2="1"
								>
									<stop
										offset="60%"
										stopColor="#82ca9d"
										stopOpacity={0.8}
									/>
									<stop
										offset="95%"
										stopColor="#82ca9d"
										stopOpacity={0}
									/>
								</linearGradient>
							</defs>
							<XAxis dataKey="name" />
							<YAxis />
							<CartesianGrid strokeDasharray="3 3" />
							<Tooltip />
							<Area
								type="monotone"
								dataKey="pv"
								stroke="#27AE60"
								fillOpacity={1}
								fill="url(#colorPv)"
							/>
						</AreaChart>
					</ResponsiveContainer>
				</div>
			</div>
		</div>
	);
};

export default CustomChartLineCard;
